module.exports = __webpack_public_path__ + "img/Selection_009.9186904e.png";